import { useEffect } from 'react'

import { useGetTrackRightsSplitsQuery } from '@disco/state-management/api/rights-splits'

type Props = {
  trackId: number
  hasIsrc: boolean
  hasIswc: boolean
  onDataLoaded: (hasData: boolean) => void
}

/**
 * Renders nothing — just fetches whether a read-only track has any rights
 * data, independent of whether the Rights tab is the active tab. Lives
 * outside Tabs.Content on purpose: that only mounts the active tab's
 * children, so a query placed inside it never runs until the user has
 * already clicked into Rights, which defeats hiding the tab up front.
 */
const RightsDataPrefetch = ({
  trackId,
  hasIsrc,
  hasIswc,
  onDataLoaded,
}: Props): null => {
  const { data, isSuccess } = useGetTrackRightsSplitsQuery({ trackId })

  useEffect(() => {
    if (!isSuccess) return
    onDataLoaded((data?.length ?? 0) > 0 || hasIsrc || hasIswc)
  }, [isSuccess, data, hasIsrc, hasIswc, onDataLoaded])

  return null
}

export default RightsDataPrefetch
